module.exports = __webpack_public_path__ + "img/checkpoint-banner.215ca1f5.jpg";